import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
@Injectable(
  {
  providedIn: 'root'
  }
)
export class AuthGuard implements CanActivate {
  constructor(private afAuth: AngularFireAuth, private router: Router, public authService: AuthService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.afAuth.authState.take(1).map(user => !!user).do(async loggedIn => {
      if (loggedIn) {
        return true;
      }else{
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    })
  }
}
